import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PageHeader } from "../../components/common";
import { api, errMsg } from "../../lib/api";
import { MyLeaveRequests } from "../../components/attendance/LeaveRequests";
import { HolidaysTab } from "../../components/attendance/HolidaysTab";

/** Phase 168 — supervisor portal: own leave requests + the holiday calendar (read-only). */
export default function LeaveRequests() {
  const { code } = useParams();
  const [items, setItems] = useState(null);
  const [error, setError] = useState(null);
  const load = useCallback(() => {
    api.get(`/t/${code}/attendance/leave-requests`).then((r) => { setItems(r.data.items); setError(null); }).catch((e) => setError(errMsg(e)));
  }, [code]);
  useEffect(() => { load(); }, [load]);
  return (
    <div data-testid="supervisor-leave-page">
      <PageHeader title="Leave & holidays" subtitle="Request a day off (the admin approves or rejects with a reason) and see the municipality's holiday calendar" />
      {error && <p className="text-sm text-destructive mb-3">{error}</p>}
      <div className="space-y-3">
        <MyLeaveRequests code={code} items={items} onChanged={load} />
        <HolidaysTab code={code} readOnly />
      </div>
    </div>
  );
}
